var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"baseBtn",class:_vm.type,style:({ width: _vm.width }),attrs:{"type":"submit","disabled":_vm.isDisable},on:{"click":function($event){$event.preventDefault();return _vm.clickEvent.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }